module.exports = __webpack_public_path__ + "images/pages/for_business/sp/sec07_a79158bb4393cf60f25062617afe5119.jpg";